export default {
  app: 'APP_ZIKA',
  api: '/portal'
};
